import React, { Component } from "react";
import MapSVG from '../MapSVG/MapSVG';
import "./Welcome.scss";
import JSONPins from "../../static/api/data.json";
import Cards from "../Cards/Cards";
import NavBar from "../NavBar/NaBar";
import { GA_Push, GA_VPush } from "../Services/GoogleAnalytics";
import { __CurrentAreas__ } from "../Helpers/ArrayGrouping";

const ini8State = {
    loopState: "",
    pinActive: 0,
    alreadyZoom: false
}
export default class Welcome extends Component {
    constructor() {
        super();
        this.renderPins = this.renderPins.bind(this);
        this.startButton = this.startButton.bind(this);
        this.clickPin = this.clickPin.bind(this);
        this.resetState = this.resetState.bind(this);
        this.state = {
            ...ini8State
        }
    }
    componentDidMount() {
        window.addEventListener("menuPinClicked", (event) => {
            this.setState({
                loopState: "stop",
                pinActive: event.detail,
                alreadyZoom: true
            })
        });
        window.document.querySelector("#footer").classList.remove("hide");
        window.addEventListener("orientationchange", () =>
            window.setTimeout(() => this.setState({
                svgBox: window.document.querySelector(".map_index_0 svg g") ?
                    window.document.querySelector(".map_index_0 svg g").getBoundingClientRect() : null
            }), 350));
        window.addEventListener("resize", () =>
            window.setTimeout(() => this.setState({
                svgBox: window.document.querySelector(".map_index_0 svg g") ?
                    window.document.querySelector(".map_index_0 svg g").getBoundingClientRect() : null
            }), 350));
    }
    startButton() {
        this.setState({
            loopState: "stop",
            svgBox: window.document.querySelector(".map_index_0 svg") ?
                window.document.querySelector(".map_index_0 svg g").getBoundingClientRect() : null
        });
        window.document.querySelector("#footer").classList.add("hide");
    }
    clickPin(index) {
        this.setState({
            pinActive: index
        }, () => {
            window.setTimeout(() => {
                this.setState({
                    alreadyZoom: true
                })
            }, 1500);
            GA_VPush(__CurrentAreas__(index)[0].Mainland + " - קריאה אחרונה", `${window.location.pathname}/${__CurrentAreas__(index)[0].Land}/?prof=2.News-192.the.world-LastCall`);
            window.dispatchEvent(new CustomEvent("pinClicked", {
                "detail": index
            }));
        })

    }
    resetState() {
        // window.document.querySelector("#footer").classList.remove("hide");
        this.setState({
            // ...ini8State
            // loopState: ""
            pinActive: 0,
            alreadyZoom: false
        }, () => {
            this.welcome.scrollLeft = this.welcome.scrollWidth;
            this.setState({
                svgBox: window.document.querySelector(".map_index_0 svg") ?
                    window.document.querySelector(".map_index_0 svg g").getBoundingClientRect() : null
            })
            // this.startButton();
            window.dispatchEvent(new CustomEvent("pinClicked", {
                "detail": 0
            }));
        })
    }
    renderPins() {
        let obj = [];
        return JSONPins.map((item, index) =>
            <div key={index}
                onClick={() => {
                    this.clickPin(index + 1);
                    GA_Push("Continent_Clicked", item.name + " - Map");
                }}
                className={`pins pins-${index + 1}`}>
                <div className="region">{item.name}</div>
                {((item, index) => {
                    let obj = [];
                    for (let i = 0; i < 4; i++) {
                        obj.push(<div key={index + i} className={`pin pin-${i + 1}`}></div>)
                    }
                    return obj;
                })(item, index)}
            </div>
        )
    }
    render() {
        return (
            <section
                ref={welcome => this.welcome = welcome}
                className={`section section-welcome${this.state.loopState != "" ? " active" : ""}${this.state.pinActive ? ` zoom-${this.state.pinActive}` : ""}${this.state.alreadyZoom ? " zoomed" : ""}`}>
                {this.state.pinActive > 0 ? <NavBar
                    area={this.state.pinActive}
                    setLocation={this.clickPin}
                    resetState={this.resetState} /> : ""}
                <div className="loop-container">
                    <div className={`loop ${this.state.loopState}`} id="loop">
                        <MapSVG index={0}
                            loopState={this.state.loopState}
                            pins={this.state.svgBox ?
                                <InnerAreas
                                    svgBox={this.state.svgBox}
                                    renderPins={this.renderPins}
                                /> : null}
                        />
                        {this.state.loopState == "" ?
                            <MapSVG index={1}
                                loopState={this.state.loopState} /> : ""}
                    </div>
                </div>
                <Cards
                    resetState={this.resetState}
                    area={this.state.pinActive} />
                <InnerHeadline
                    startButton={() => {
                        GA_Push("Started Tour");
                        this.startButton();
                    }} />
            </section>
        )
    }
}

const InnerAreas = props => {
    return (
        <div className="areas">
            <div className="areas-container" style={{
                width: props.svgBox.width,
                height: props.svgBox.height
            }}>
                {props.renderPins()}
            </div>
        </div>
    )
}

const InnerHeadline = props => {
    return (
        <div className={`headline`}>
            <div className="head">
                קריאה אחרונה
            </div>
            <div className="slogen">
                מסע עולמי בין 50 הכתבות הטובות של השנה
            </div>
            <div className="desc">
                מאמריקה עד בהוטן, מאוסטרליה עד קירגיזסטן:<span><br /></span> לחצו על היבשות וצאו לטיול בין הסיפורים הכי מרתקים שאספנו לכם ב-2018
            </div>
            <div className="editors">
                עורכי הפרויקט: אייל להמן ויואב תירוש
            </div>
            <div className="button" onClick={props.startButton}>
                קח אותי לסיבוב בעולם
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.jsx